// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//新导入的包
import axios from "axios";
import qs from "qs";
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import store from "./store/store";
import VueClipboard from 'vue-clipboard2'

//新添加的
Vue.prototype.$axios=axios
Vue.prototype.$qs=qs
Vue.use(ElementUI)  //声明插件安装
Vue.use(VueClipboard)	//声明复制剪贴板插件

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  //新添加的
  store,

  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js